(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define([], factory);
    } else if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory();
    } else {
        // Browser globals (Note: root is window)
        root.EllipsisText = factory();
    }

})(this, function () {
    function truncate($elements, customConfig) {
        var options = mergeTruncateConfigurations(customConfig);

        if (options.width !== "auto") {
            $elements = filterElements($elements, options.width);
        }

        initEllipsisTooltip($elements, options.customTooltip);

        $elements.trunk8(options);
    }

    /**
     * Merge default and custom configurations
     * @param customConfig
     * @return {jQuery}
     */
    function mergeTruncateConfigurations(customConfig) {
        var defaultOptions = {
            lines: 2,
            tooltip: false, // prevent built in tooltip
            customTooltip: true,
            fill: "<a class='ellipsisText' href='javascript:;'>&hellip;</a>",
            width: 60
        };

        if (customConfig) {
            // default is set on true, but when fill is defined on customOptions,
            // this property is disabled so the only functionality of this plugin is just to truncate text
            defaultOptions.customTooltip = !customConfig.fill
        }

        return $.extend(true, {}, defaultOptions, customConfig);
    }

    /**
     * Filter elements that have length > width (in characters) in order to be truncated
     * @param $elements
     * @param width
     * @return {*}
     */
    function filterElements($elements, width) {
        return $elements.filter(function () {
            var value = this.innerText;

            return value.length > width;
        });
    }

    /**
     * Initialize tooltip triggered by clicking on ellipsis element
     * @param $elements
     * @param hasCustomTooltip
     */
    function initEllipsisTooltip($elements, hasCustomTooltip) {
        // tooltipster configuration
        var tooltipsterOptions = {
            trigger: 'custom',
            triggerClose: {
                click: true
            },
            side: ['bottom', 'top'],
            distance: 5,
            maxWidth: 350,
            animationDuration: [0, 0],
            arrow: false,
            functionPosition: function (instance, helper, position) {
                position.coord.left = helper.geo.origin.windowOffset.left;
                return position;
            }
        };

        // add tooltip on each element
        for (var i = 0; i < $elements.length; i++) {
            var $element = $($elements[i]);

            if (hasCustomTooltip) {
                // keep original text before truncate
                $element.data('originalText', $element.text());

                // add click event in order to show tooltip with the original text
                $element.on('click', '.ellipsisText', function () {
                    var $this = $(this);

                    var tooltipsterInstance = $this.data('tooltipster');

                    if (!tooltipsterInstance) {
                        tooltipsterInstance = $this.tooltipster(tooltipsterOptions);
                        tooltipsterInstance.tooltipster('content', $element.data('originalText'));

                        $this.data('tooltipster', tooltipsterInstance);
                    }

                    tooltipsterInstance.tooltipster('open');
                });
            }
        }
    }

    return {
        truncate: truncate
    }
});